/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {   
    auth: {
        clientId: "b8c58b30-854c-44a7-8a54-75411d0440d7",
        authority: "https://login.microsoftonline.com/" + "46c98d88-e344-4ed4-8496-4ed7712e255d",
        redirectUri: ""
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        //console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        //console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        //console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        //console.warn(message);		
                        return;		
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphAssignmentRequestEndpoint: "https://graph.microsoft.com/v1.0/identityGovernance/entitlementManagement/assignmentRequests",
    graphAssignmentEndpoint: "https://graph.microsoft.com/v1.0/identityGovernance/entitlementManagement/assignments/",
    graphAssignmentListEndpoint: "https://graph.microsoft.com/v1.0/identityGovernance/entitlementManagement/assignments/microsoft.graph.filterByCurrentUser(on='target')?$select=id,state,schedule&$count=true&$top=5&&$filter=accessPackage/id eq '285acbbc-7cbe-49b6-bc6c-3e938922526a'",
    graphAssignmentListEndpointMac: "https://graph.microsoft.com/v1.0/identityGovernance/entitlementManagement/assignments/microsoft.graph.filterByCurrentUser(on='target')?$select=id,state,schedule&$count=true&$top=5&&$filter=accessPackage/id eq '6878eb95-3815-48df-b7dd-714695b03d06'"
};
